<template>
	<div class="content-wrapper">
		<!-- Content -->
		<div class="container-xxl flex-grow-1 container-p-y">
			<!-- Sticky Actions -->
			<div class="row">
				<div class="col-12">
					<div class="card">
						<div
							class="card-header sticky-element bg-label-secondary d-flex justify-content-sm-between align-items-sm-center flex-column flex-sm-row">
							<h5 class="card-title mb-sm-0 me-2">Ajouter un nouveau salarié</h5>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-lg-8 mx-auto">

								<!-- 2. Delivery Type -->
									<h5 class="my-6">1. Type de compte</h5>
									<div class="row gy-3">
										<div class="col-md">
											<div class="form-check custom-option custom-option-icon">
												<label class="form-check-label custom-option-content" for="customRadioIcon1">
													<span class="custom-option-body">
														<i class="ri-user-line"></i>
														<span class="custom-option-title mb-2"> Stagiaire </span>
														<small> compte qui permet<br/>de faire les formations. </small>
													</span>
													<input
														name="customDeliveryRadioIcon"
														class="form-check-input"
														type="radio"
														value="trainee"
														id="customRadioIcon1"
														v-model="form.role"
														checked />
												</label>
											</div>
										</div>
										<div class="col-md">
											<div class="form-check custom-option custom-option-icon">
												<label class="form-check-label custom-option-content" for="customRadioIcon2">
													<span class="custom-option-body">
														<i class="ri-vip-crown-line"></i>
														<span class="custom-option-title mb-2"> Manager </span>
														<small> compte qui permet d'avoir<br />accès à l'interface manager.</small>
													</span>
													<input
														name="customDeliveryRadioIcon"
														class="form-check-input"
														type="radio"
														value="manager"
														id="customRadioIcon2"
														v-model="form.role"
													/>
												</label>
											</div>
										</div>
									</div>
									<hr />
									<!-- 1. Delivery Address -->
									<h5 class="mb-4">2. Informations du salarié </h5>

									<div class="row g-6">
										<div class="col-md-6">
											<div class="form-floating form-floating-outline">
												<input type="text" id="fullname" class="form-control" placeholder="John Doe" v-model="form.firstName" />
												<label for="fullname">Prénom</label>
												<small v-if="errors.firstName" class="text-danger">{{ errors.firstName }}</small>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-floating form-floating-outline">
												<input type="text" id="fullname" class="form-control" placeholder="John Doe" v-model="form.lastName" />
												<label for="fullname">Nom</label>
												<small v-if="errors.lastName" class="text-danger">{{ errors.lastName }}</small>
											</div>
										</div>
										<div class="col-md-6">
											<div class="input-group input-group-merge">
												<div class="form-floating form-floating-outline">
													<input
														class="form-control"
														type="text"
														id="email"
														name="email"
														placeholder="john.doe"
														aria-label="john.doe"
														aria-describedby="email3"
														v-model="form.email"
													/>
													<label for="email">Email</label>
													<small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
												</div>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-floating form-floating-outline">
												<input 
													type="text"
													id="bs-datepicker-basic"
													placeholder="DD/MM/YYYY"
													class="form-control"
													ref="birthDate"
													@input="handleDateInput"
													v-model="form.birthDate"
												/>
												<label for="bs-datepicker-basic">Date de de naissance</label>
												<small v-if="errors.birthDate" class="text-danger">{{ errors.birthDate }}</small>
											</div>
										</div>
									</div>
									<hr />
								</div>
							</div>
						</div>
					</div>
					<div
						class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
						<div class="d-flex flex-column justify-content-center">
							
						</div>
						<div class="d-flex align-content-center flex-wrap gap-4 mt-5">
							<router-link to="/employees/list">
								<button class="btn btn-outline-secondary">Retour</button>
							</router-link>
							<button type="submit" class="btn btn-primary" @click="createEmployee()">Créer le salarié</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HTTP from "@/axios";

export default {
	name: "CreateEmployee",

	data() {
		return { 
			form: {
				firstName: "",
				lastName: "",
				email: "",
				birthDate: null,
				role: "trainee"
			},
			errors: {},
		};
	},

	methods: {
		handleDateInput(event) {
			let input = event.target.value;

			// Enlever tous les caractères non numériques
			input = input.replace(/\D/g, '');

			// Formatage automatique en DD/MM/YYYY
			if (input.length <= 2) {
				this.form.birthDate = input;
			} else if (input.length <= 4) {
				this.form.birthDate = `${input.slice(0, 2)}/${input.slice(2)}`;
			} else {
				this.form.birthDate = `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`;
			}
		},

		clearError(field) {
			// Supprime l'erreur pour le champ spécifié
			if (this.errors[field]) {
				delete this.errors[field];
			}
		},

		validateForm() {
			this.errors = {};

			if (!this.form.firstName) {
				this.errors.firstName = "Le prénom est obligatoire.";
			}
			if (!this.form.lastName) {
				this.errors.lastName = "Le nom est obligatoire.";
			}
			if (!this.form.email || !this.validateEmail(this.form.email)) {
				this.errors.email = "Veuillez entrer une adresse e-mail valide.";
			}

			return Object.keys(this.errors).length === 0;
		},

		validateEmail(email) {
			const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return re.test(email);
		},

		async createEmployee() {
			const validated = this.validateForm();

			if (!validated)
				return;

			if (!this.form.birthDate)
				delete this.form.birthDate;

			try {
				await HTTP.post('/company/employees/create', this.form);
				this.$router.push("/employees/list");
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		}
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}
</style>
